<template>
    <b-modal
        id="alternativeProductsModal"
        size="xl"
        :ref="_uid"
        :hide-footer="true"
        title="Alternative Products"
        @hidden="handleScrollToTop()"
    >
        <shippingOptionsCards
            class="alternativeModalStyling ml-4"
            @create-shipment="$emit('create-shipment', $event)"
            @create-prebooking="$emit('create-prebooking', $event)"
            :products="alternativeProducts"
            :isAlternative="true"
            :get-shipment-price="getShipmentPrice"
        ></shippingOptionsCards>
    </b-modal>
</template>
<script>
  import { mapState, mapGetters } from 'vuex';
  import shippingOptionsCards from './shippingOptionsCards';
  import helper from '../helper';

  export default {
      props:{
          getShipmentPrice: {type: Function, required:true}
      },
      data() {
          return {
              scrollToTopOnClose: false,
              alternativeProducts: null,
          };
      },

      components: {
          shippingOptionsCards,
      },

      methods: {
          getModalSize() {
              if (this.alternativeProducts !== null) {
                  if (this.alternativeProducts[0].length < 4) {
                      return 'lg';
                  }
              }

              return 'xl';
          },

          handleScrollToTop() {
              if (this.scrollToTopOnClose) {
                  this.$nextTick().then(() => {
                      window.scrollTo(0, 0);
                  });
              }
          },

          hide(scrollToTopOnClose) {
              this.scrollToTopOnClose = scrollToTopOnClose;
              this.$bvModal.hide('alternativeProductsModal');
          },

          show(item) {
              this.scrollToTopOnClose = false;

              this.$refs[this._uid].show();

              let currentProduct = helper.cloneObject(item);

              currentProduct.alternativeBooking = false;

              currentProduct.alternativeProducts = null;

              item.alternativeProducts.forEach((x) => {
                  x.alternativeBooking = true;
              });

              this.alternativeProducts = _.chunk(Object.values(item.alternativeProducts), 3);

              this.alternativeProducts[0].unshift(currentProduct);
          },
      },
  };
</script>

<style>
  .alternativeModalStyling .shippingOptionCard {
      /* min-width: max-content !important; */
      min-width: 23% !important;
      max-width: 23% !important;
  }
</style>
